import { Box, Flex, SimpleGrid, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { IterationComponent } from '@components/functionComponent';
import SkeletonComponent from '@components/skeleton';
import '../styles.scss';

const SelloutMonitoringSkeleton = () => {
    return (
        <Flex minW={'xl'} gap={'24px'} flexDirection={'column'}>
            <Box bg="white" p="24px" border="1px solid" borderColor="neutral.100" borderRadius="8px" boxShadow="sm">
                <Flex gap="8px" alignItems="center">
                    <SkeletonComponent height={'36px'} width={'200px'} />
                </Flex>

                <SimpleGrid columns={{ base: 2, md: 3, xl: 5 }} gap="16px" alignItems="end" mt="17px">
                    <IterationComponent
                        arr={[1, 2, 3, 4]}
                        render={(_, index) => (
                            <Flex key={index} direction="column" gap="12px">
                                <SkeletonComponent height={'16px'} width={'100px'} />
                                <SkeletonComponent height={'40px'} width={'100%'} />
                            </Flex>
                        )}
                    />
                    <SkeletonComponent height={'40px'} maxWidth={'200px'} width={'100%'} />
                </SimpleGrid>
            </Box>

            <Box bg="white" p="24px" border="1px solid" borderColor="neutral.100" borderRadius="8px" boxShadow="sm">
                <Flex justifyContent="space-between" mb="16px" flexWrap={'wrap'} gap={'8px'}>
                    <SkeletonComponent height={'28px'} width={'150px'} />
                    <SkeletonComponent height={'24px'} width={'250px'} />
                </Flex>

                <Flex justify="space-between" mb="24px">
                    <Flex gap="24px" me={'24px'}>
                        <SkeletonComponent height={'40px'} width={'300px'} />
                        <SkeletonComponent height={'40px'} width={'90px'} />
                        <SkeletonComponent height={'40px'} width={'100px'} />
                    </Flex>
                    <SkeletonComponent height={'40px'} width={'120px'} />
                </Flex>

                <Table>
                    <Thead>
                        <Tr className="row-head__container row-skeleton">
                            <Th maxWidth="40px">
                                <SkeletonComponent width={'16px'} height={'16px'} />
                            </Th>
                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'60px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px" float="left">
                                    <SkeletonComponent width={'80px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'40px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'80px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'80px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'40px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>

                            <Th>
                                <Flex alignItems="center" gap="8px">
                                    <SkeletonComponent width={'80px'} height={'17px'} />
                                    <SkeletonComponent width={'12px'} height={'12px'} />
                                </Flex>
                            </Th>
                            <Th>
                                <SkeletonComponent width={'36px'} height={'16px'} />
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <IterationComponent
                            arr={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                            render={(_, index) => (
                                <Tr className="row-column__container row-skeleton" key={index}>
                                    <Td padding="0 12px" maxWidth="40px">
                                        <SkeletonComponent width={'16px'} height={'16px'} />
                                    </Td>
                                    <Td>
                                        <SkeletonComponent width={'100px'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'100%'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'64px'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'100%'} maxWidth={'144px'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'100%'} maxWidth={'144px'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'100%'} maxWidth={'144px'} height={'20px'} />
                                    </Td>

                                    <Td>
                                        <SkeletonComponent width={'100px'} height={'20px'} />
                                    </Td>
                                    <Td>
                                        <SkeletonComponent float="center" width={'62px'} height={'36px'} />
                                    </Td>
                                </Tr>
                            )}
                        />
                    </Tbody>
                </Table>
            </Box>
        </Flex>
    );
};

export default SelloutMonitoringSkeleton;
